/*
 * Purpose : Common component for Sales screen Button
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React from 'react';
import { FormGroup, Button } from "reactstrap";

import './ToolSalesButton.css';

const ToolSalesButton = (props) => {
    return (
        <FormGroup>
            <Button
                className={"salesBtn"}
                style={{ backgroundColor: "#fb8734" }}
                {...props}
            >{props.children}
            </Button>
        </FormGroup>
    )
}

export default ToolSalesButton
